import ProfilePhotoUpload from './ProfilePhotoUpload';

export default ProfilePhotoUpload;
